import { createFileRoute } from '@tanstack/react-router';
import { SubmissionsPage } from '@/pages/forms/submissions/SubmissionsPage';
import { z } from 'zod';

const searchSchema = z.object({
	page: z.number().optional().catch(undefined),
	pageSize: z.number().optional().catch(undefined),
	search: z.string().optional().catch(undefined),
	createdFrom: z.string().optional().catch(undefined),
	createdTo: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/_app/forms/$formId/submissions')({
	component: SubmissionsPage,
	validateSearch: searchSchema,
});
